import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

console.log('Rendering CTASection');

const CTASection = () => {
  return (
    <section className="py-16 md:py-20 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary/10 via-accent/5 to-primary/10 border border-primary/20">
          <div className="absolute inset-0 bg-grid-pattern opacity-5" />
          
          <div className="relative z-10 px-6 md:px-12 lg:px-16 py-12 md:py-16 lg:py-20">
            <div className="max-w-3xl mx-auto text-center">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-success/10 border border-success/20 mb-6">
                <div className="w-2 h-2 rounded-full bg-success animate-pulse" />
                <span className="text-sm font-medium text-success">Currently Available</span>
              </div>

              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground mb-6">
                Ready to Build Something
                <span className="block text-primary mt-2">Production-Ready?</span>
              </h2>

              <p className="text-base md:text-lg lg:text-xl text-muted-foreground mb-8 md:mb-10 leading-relaxed">
                Let's discuss your project requirements and explore how we can create scalable solutions that deliver measurable business impact. From concept to deployment, I'll be your technical partner every step of the way.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8 md:mb-10">
                <Button
                  variant="default"
                  size="lg"
                  iconName="Rocket"
                  iconPosition="right"
                  className="w-full sm:w-auto"
                  asChild
                >
                  <Link to="/contact">Start Your Project</Link>
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  iconName="Calendar"
                  iconPosition="left"
                  className="w-full sm:w-auto"
                  asChild
                >
                  <Link to="/contact">Schedule a Call</Link>
                </Button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 pt-8 border-t border-border">
                <div className="flex flex-col items-center gap-3">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary/10">
                    <Icon name="Zap" size={24} color="var(--color-primary)" />
                  </div>
                  <div className="text-center">
                    <div className="font-bold text-foreground mb-1">Fast Response</div>
                    <div className="text-sm text-muted-foreground">Reply within 24 hours</div>
                  </div>
                </div>

                <div className="flex flex-col items-center gap-3">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-success/10">
                    <Icon name="Shield" size={24} color="var(--color-success)" />
                  </div>
                  <div className="text-center">
                    <div className="font-bold text-foreground mb-1">Quality Guaranteed</div>
                    <div className="text-sm text-muted-foreground">Production-grade code</div>
                  </div>
                </div>

                <div className="flex flex-col items-center gap-3">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-warning/10">
                    <Icon name="Users" size={24} color="var(--color-warning)" />
                  </div>
                  <div className="text-center">
                    <div className="font-bold text-foreground mb-1">Collaborative</div>
                    <div className="text-sm text-muted-foreground">Clear communication</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 text-center">
          <p className="text-sm md:text-base text-muted-foreground mb-4">
            Prefer to connect on social media?
          </p>
          <div className="flex justify-center gap-4">
            {[
              { icon: 'Github', url: 'https://github.com', label: 'GitHub' },
              { icon: 'Linkedin', url: 'https://linkedin.com', label: 'LinkedIn' },
              { icon: 'Twitter', url: 'https://twitter.com', label: 'Twitter' },
              { icon: 'Mail', url: 'mailto:contact@mikedev.pro', label: 'Email' }
            ]?.map((social) => (
              <a
                key={social?.label}
                href={social?.url}
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center rounded-full bg-card border border-border hover:border-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 hover:-translate-y-1"
                aria-label={social?.label}
              >
                <Icon name={social?.icon} size={20} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;